import Store from '@/store';

export function undoSuccess() {
  Store.commit('undoSuccess');
}

export function setSuccess(message: string) {
  Store.commit('onSuccess', message);
}
